import { Request } from 'components/Request';

export const GET_INFRACTION_TYPES_BEGIN = 'GET_INFRACTION_TYPES_BEGIN';
export const GET_INFRACTION_TYPES_SUCCESS = 'GET_INFRACTION_TYPES_SUCCESS';
export const GET_INFRACTION_TYPES_FAIL = 'GET_INFRACTION_TYPES_FAIL';

export const getInfractionTypes = () => (dispatch, getState) => {
	const { mod } = getState();
	if(mod.loadingInfractionTypes) {
		console.log('Already retrieving infraction types');
		return;
	}
	dispatch({
		type: GET_INFRACTION_TYPES_BEGIN
	});
	Request.apiv1Get('infraction/types')
		.then((response) => {
			dispatch({
				type: GET_INFRACTION_TYPES_SUCCESS,
				payload: response.types
			});
		})
		.catch((error) => {
			Request.generalJsonError(error);
			dispatch({
				type: GET_INFRACTION_TYPES_FAIL,
			});
		});

};
